import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import { useCrudSelection, resetCrudSelection, useEditingStateWithCtx } from '@/atoms'
import { selectEventAlertsListStructure } from '@/features/domain/lists'
import { fitMapToSelection } from '@/map'

export function useTitle() {
  const listStructure = useSelector(selectEventAlertsListStructure)
  const { editing } = useEditingStateWithCtx('alert')

  const [selection, select] = useCrudSelection('alerts')

  const onSelectAll = useCallback(() => {
    const allSelected = listStructure.shownItems <= selection.length

    if (allSelected) {
      resetCrudSelection('alerts')
    } else {
      select(
        listStructure.list.reduce<string[]>((acc, item) => {
          if (typeof item === 'string') {
            acc.push(item)
          }
          return acc
        }, []),
      )

      fitMapToSelection({ preventIfVisible: true }, 'add')
    }
  }, [select, selection, listStructure])

  return {
    editing,
    selection,
    onSelectAll,
    listStructure,
    noEntries: listStructure.totalItems === 0,
  }
}
